import gql from 'graphql-tag';

export const listNotifications = gql`
	query listNotifications($gameId: ID!) {
		getGame(id: $gameId) {
			notifications {
				items {
					id
					notificationType
					timestamp
					title
					minute
					teamId
					score
					updatedAt
				}
			}
		}
	}
`;
